import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiHandle } from "../config/apiHandle.js";
import { type_constant } from "../utils/asyncStatus.js";

export const getAllProductsAsync = createAsyncThunk(
  type_constant.GET_ALL_PRODUCTS_ASYNC,
  async ({ page = 1, limit = 15 }) => {
    try {
      const response = await apiHandle.get(`/get-my-products`, {
        params: {
          page,
          limit
        }
      });
      const res_data = await response.data;
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);

export const getProductByIdAsync = createAsyncThunk(
  type_constant.GET_PRODUCT_BY_ID_ASYNC,
  async (id) => {
    try {
      const response = await apiHandle.get(`/view-product/${id}`);
      const res_data = await response.data;
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);

export const updateProductAsync = createAsyncThunk(
  type_constant.UPDATE_PRODUCT_ASYNC,
  async (updatedData) => {
    const { id, post_data } = updatedData;
    try {
      const response = await apiHandle.post(`/edit-product/${id}`, post_data);
      const res_data = await response.data;
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);

export const addProductAsync = createAsyncThunk(
  type_constant.ADD_PRODUCT_ASYNC,
  async (postData) => {
    try {
      const response = await apiHandle.post(`/add-product`, postData);
      const res_data = await response.data;
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);

export const myProductsDetailsAsync = createAsyncThunk(
  type_constant.MY_PRODUCT_DETAILS_ASYNC,
  async () => {
    try {
      const response = await apiHandle.get(`/my-details`);
      const res_data = await response.data;
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);
